export enum TaxRegimeEnum {
	SIMP_NACIONAL = "SIMP_NACIONAL",
	SIMP_REC_BRUTA = "SIMP_REC_BRUTA",
	REGIME_NORMAL = "REGIME_NORMAL",
	SIMP_NACIONAL_MEI = "SIMP_NACIONAL_MEI"
}
